<button pButton type="button" label="Add User" (click)="showAddDialog()"
    *ngIf="relationshipWithAddUserCount > 0"></button>
<p-messages [value]="messages"></p-messages>
<p-table #dt [value]="userRelationshipGroup" autoLayout=true [paginator]="true" [loading]="loading" [rows]="10" [rowsPerPageOptions]="[10,25,50,100]"
     [globalFilterFields]="['PersonDetail.FirstName', 'PersonDetail.LastName', 'PersonDetail.Phone', 'PersonDetail.Email']"
      dataKey="PersonDetail.PersonId">
    <ng-template pTemplate="caption">
        <div class="search-container">        
            <i class="pi pi-search filterInput"></i>
            <input type="text" pInputText size="50" placeholder="Filter By: Name, Phone and Email" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3em"></th>
            <th>Status</th>
            <th [pSortableColumn]="'PersonDetail.FirstName'">Name <p-sortIcon [field]="'PersonDetail.FirstName'"></p-sortIcon></th>
            <th>Phone</th>
            <th>Email</th>
            <th>Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user let-expanded="expanded">
        <tr>
            <td>
                <a href="#" [pRowToggler]="user">
                    <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
                </a>
            </td>
            <td>{{user.PersonDetail.IsActive ? 'Active' : 'Inactive'}}</td>
            <td>
                <span *ngIf="user.PersonDetail.LastName">{{user.PersonDetail.LastName}}, </span>{{user.PersonDetail.FirstName}}
            </td>
            <td>{{user.PersonDetail.Phone | phone}}</td>
            <td>{{user.PersonDetail.Email}}</td>
            <td>
                <span *ngIf="canManageUser(user)">
                    <i class="pi pi-fw pi-pencil action" (click)="editUser(user)">
                    </i>
                    <i class="pi pi-fw pi-trash action" (click)="removeUser(user)"
                        *ngIf="user.PersonDetail.IsActive">
                    </i>
                </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-user>
        <tr>
            <td class="noBorderR"></td>
            <td [attr.colspan]=5 class="noBorderL">
                <div class="rowExpandcontent">
                    <p-table [value]="user.Relationship" autoLayout=true responsive="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <td colspan="3">
                                    <span class="bold-label">Access</span>
                                    <button pButton 
                                        type="button"
                                        label="Add Partnership"
                                        (click)="addUserPartnership(user)"
                                        *ngIf="canAddUserAccess(user)">
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <th>Partnership</th>
                                <th>Asset Groups</th>
                                <th>Privileges</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-relationship let-rowIndex="rowIndex">
                            <tr>
                                <td>{{relationship.RelationshipName | titlecase}}</td>
                                <td>
                                    <span *ngIf="relationship.RelationshipDataGroup.length < 2">
                                    {{userRelationshipSvc.assetGroupList(relationship.RelationshipDataGroup)}}
                                    </span>
                                    <span *ngIf="relationship.RelationshipDataGroup.length >= 2">
                                        {{userRelationshipSvc.assetGroupList(relationship.RelationshipDataGroup.slice(0,1))}}
                                        <i class="hoverLink" (mouseover)="displayMoreDialog(moreDialog, $event,relationship.RelationshipDataGroup,'ASSETGROUP')"
                                        (mouseout)="moreDialog.hide($event)">+More</i>
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{userRelationshipSvc.privilegeList(relationship.Privileges,relationship.PrivilegeGroups).substr(0,40)}}
                                    <i class="hoverLink" 
                                        (mouseover)="displayMoreDialog(privilegMoreDialog, $event, relationship,'PRIVILEGES')" 
                                        (mouseout)="privilegMoreDialog.hide($event)">+More</i>
                                    </span> 
                                </td>
                                <td>
                                    <i class="pi pi-fw pi-pencil action" (click)="editUserRelationship(user,rowIndex)"
                                        *ngIf="user.PersonDetail.IsActive && relationship.CanAddUser">
                                    </i>
                                    <i class="pi pi-fw pi-trash action" (click)="removeUserRelationshipConfirm(user,rowIndex)"
                                     *ngIf="user.PersonDetail.IsActive && relationship.CanAddUser">
                                    </i>      
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<app-edit-user [displayDialog]="displayEditDialog" (onDialogClose)="dialogEditAction($event)" 
    [userRelationship]="userRelationshipSelected" (onEditUser)="updateUser($event)" 
    *ngIf="displayEditDialog && userRelationshipSelected" (onMessage)="onMessage($event)">
</app-edit-user>
<app-add-user [displayDialog]="displayAddDialog"
 (onDialogClose)="dialogAddAction($event)" (onAddUser)="addUser($event)" *ngIf="displayAddDialog" 
 [relationshipWithOutCanAddUser]= "relationshipWithOutCanAddUser"
 (onMessage)="onMessage($event)">
</app-add-user>
<app-edit-user-access 
    [displayDialog]="displayEditUserAccessDialog" (onDialogClose)="dialogUserAction($event)" 
    [userRelationship]="userRelationshipSelected" (onEditUser)="updateUser($event)"
    [relationshipIndex]="relationshipSelectedIndex"
    *ngIf="displayEditUserAccessDialog && userRelationshipSelected"
    (onMessage)="onMessage($event)">
</app-edit-user-access>
<app-add-user-access 
    [displayDialog]="displayAddUserAccessDialog" (onDialogClose)="dialogUserAction($event)" 
    [userRelationship]="userRelationshipSelected" (onEditUser)="updateUser($event)"
    [relationshipWithOutCanAddUser]="relationshipWithOutCanAddUser"
    *ngIf="displayAddUserAccessDialog && userRelationshipSelected"
    (onMessage)="onMessage($event)">
</app-add-user-access>
<app-inactivate-user [displayDialog]="displayInactivateDialog" (onDialogClose)="dialogEditAction($event)" 
    [userRelationship]="userRelationshipSelected" (onEditUser)="updateUser($event)" 
    *ngIf="displayInactivateDialog && userRelationshipSelected" (onMessage)="onMessage($event)">
</app-inactivate-user>
<p-overlayPanel #moreDialog [dismissable]="true">
    {{moreDialogData}}
</p-overlayPanel>
<p-overlayPanel #privilegMoreDialog class="noFlicker" [dismissable]="true">
    <div *ngFor="let group of privilegeGroupMoreData">
        <ul>
            <li>
            <b>{{group.GroupName}}</b>
            <ul>
                <li *ngFor="let privilege of group.Privileges">{{privilege.PrivilegeName}}</li>
            </ul>
            </li>
        </ul>
    </div>     
    <div *ngFor="let privilege of privilegeMoreData">
        <ul>
            <li>
            {{privilege.PrivilegeName}}
            </li>
        </ul>
    </div>      
</p-overlayPanel>
<p-confirmDialog [header]="confirmHeader" icon="pi pi-exclamation-triangle"></p-confirmDialog>